module.exports = __webpack_public_path__ + "img/iphone.6117aaab.png";